////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const login = {
	getLogin: (user) => ({
		type: ActionsTypes.GET_LOGIN,
		payload: {
			...user,
		},
	}),
	getLoginSuccess: (user) => ({
		type: ActionsTypes.GET_LOGIN_SUCCESS,
		payload: {
			user,
		},
	}),
	getLoginFailure: (error) => ({
		type: ActionsTypes.GET_LOGIN_FAILURE,
		payload: {
			error,
		},
	}),

	postForgotPassword: (login) => ({
		type: ActionsTypes.POST_FORGOT_PASSWORD,
		payload: {
			login,
		},
	}),
	postForgotPasswordSuccess: (response) => ({
		type: ActionsTypes.POST_FORGOT_PASSWORD_SUCCESS,
		payload: { response },
	}),
	postForgotPasswordFailure: (error) => ({
		type: ActionsTypes.POST_FORGOT_PASSWORD_FAILURE,
		payload: {
			error,
		},
	}),
	forgotPasswordReset: () => ({
		type: ActionsTypes.POST_FORGOT_PASSWORD_RESET,
		payload: {},
	}),

	postForgotLogin: (login) => ({
		type: ActionsTypes.POST_FORGOT_LOGIN,
		payload: {
			login,
		},
	}),
	postForgotLoginSuccess: (response) => ({
		type: ActionsTypes.POST_FORGOT_LOGIN_SUCCESS,
		payload: { response },
	}),
	postForgotLoginFailure: (error) => ({
		type: ActionsTypes.POST_FORGOT_LOGIN_FAILURE,
		payload: {
			error,
		},
	}),
	forgotLoginReset: () => ({
		type: ActionsTypes.POST_FORGOT_LOGIN_RESET,
		payload: {},
	}),

	getCurrentUser: (token) => ({
		type: ActionsTypes.GET_CURRENT_USER,
		payload: {
			token,
		},
	}),
	getLogout: () => ({
		type: ActionsTypes.GET_LOGOUT,
		payload: {},
	}),
}

export default login
